<div class="modal inmodal fade in create-modal show">
	<div class="modal-dialog" [style.width.px]="modalWidth">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" (click)="closeModal()">
					<span>×</span>
					<span class="sr-only">Close</span>
				</button>
				<h4 class="modal-title">
					Account Balance Statement
					<div class="updated-on">Last Updated On: {{lastUpdate.date|date:'dd.MM.yyyy mm:hh'}}</div>
				</h4>

				<!-- Datepicker -->
				<date-interval-field class="date-interval" [(dateFrom)]="dateFrom" [(dateTo)]="dateTo"></date-interval-field>

			</div>
			<div class="modal-body">
				<table class="table table-striped table-condensed">
					<thead>
					<tr>
						<th>Date</th>
						<th>Invoice</th>
						<th>Description</th>
						<th>Amount</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let payment of accountStatements">
						<td>{{payment.date|date:'dd.MM.yyyy'}}</td>
						<td>{{payment.numberInvoice}}</td>
						<td>{{payment.description}}</td>
						<td>{{payment.amount|currency}}</td>
					</tr>
					</tbody>
					<tfoot>
					<tr>
						<th>Total</th>
						<th></th>
						<th></th>
						<th>{{total|currency}}</th>
					</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
	<div class="modal-backdrop fade in"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/account-balance-modal/account-balance-modal.component.html